import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox, EmployHERName, FlashMessage } from "../../components/common";
import _ from "lodash";
import candidateServices from "../../services/candidate.services";
import { rootReducersState } from "../../reducers";
import { updateCandidateNotifications } from "../../reducers/auth/session.reducer";

const Notifications = () => {
  const dispatch = useDispatch();
  const [alertKey, setAlertKey] = useState<number>(0);
  const [alerts, setAlerts] = useState<object>({});
  const [activityKey, setActivityKey] = useState<number>(0);
  const [activities, setActivities] = useState<object>({});
  const [supportKey, setSupportKey] = useState<number>(0);
  const [supports, setSupports] = useState<object>({});

  const areAllSelected = (data: object) => {
    const values = Object.values(data);
    return values.length > 0 && values.every((value) => value === "yes");
  };

  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session.currentUser
  );

  useEffect(() => {
    if (_.isEmpty(_.get(sessionReducer, "alert_notifications", {}))) {
      setAlerts({
        communication: "no",
        activity: "no",
        reminders: "no",
      });
    } else {
      setAlerts(JSON.parse(_.get(sessionReducer, "alert_notifications", {})));
    }
    if (_.isEmpty(_.get(sessionReducer, "activity_notifications", {}))) {
      setActivities({
        comment: "no",
        mention: "no",
        invite: "no",
        accepts_invitation: "no",
        follow: "no",
      });
    } else {
      setActivities(
        JSON.parse(_.get(sessionReducer, "activity_notifications", {}))
      );
    }
    if (_.isEmpty(_.get(sessionReducer, "support_notifications", {}))) {
      setSupports({
        privacy_policy: "no",
        unsubscribe: "no",
      });
    } else {
      setSupports(
        JSON.parse(_.get(sessionReducer, "support_notifications", {}))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAlertsChange = (event) => {
    const { checked, name } = event.target;
    checked ? (alerts[name] = "yes") : (alerts[name] = "no");
    setAlerts(alerts);
    setAlertKey((alertKey) => alertKey + 1);
  };

  const handleActivityChange = (event) => {
    const { checked, name } = event.target;
    checked ? (activities[name] = "yes") : (activities[name] = "no");
    setActivities(activities);
    setActivityKey((activityKey) => activityKey + 1);
  };

  const handleSupportChange = (event) => {
    const { checked, name } = event.target;
    checked ? (supports[name] = "yes") : (supports[name] = "no");
    setSupports(supports);
    setSupportKey((supportKey) => supportKey + 1);
  };

  const handleAlertsToggle = (data, status) => {
    Object.keys(data).forEach(function (key) {
      data[key] = status ? "yes" : "no";
    });
    setAlertKey((alertKey) => alertKey + 1);
  };

  const handleActivityToggle = (data, status) => {
    Object.keys(data).forEach(function (key) {
      data[key] = status ? "yes" : "no";
    });
    setActivityKey((activityKey) => activityKey + 1);
  };

  const handleSupportsToggle = (data, status) => {
    Object.keys(data).forEach(function (key) {
      data[key] = status ? "yes" : "no";
    });
    setSupportKey((supportKey) => supportKey + 1);
  };

  const handleUpdateNotification = async () => {
    const payload = {
      alerts,
      activities,
      supports,
    };
    try {
      const result = await candidateServices.updateNotifications({
        payload,
      });

      if (result.flag) {
        FlashMessage(result.message, "success");
        dispatch(updateCandidateNotifications(payload));
      } else {
        FlashMessage(result.message, "error");
      }
    } catch (error) {
      FlashMessage(error?.message, "error");
    }
  };

  return (
    <div className="profile-container">
      <div className="settings-header">
        <h3 className="title">Notifications</h3>
        <p className="font-md">
          Choose notification preferences and how you want to be contacted.
          Controls to make sure you only get notified about what’s important to
          you.
        </p>
      </div>
      <div className="alerts-notifications-wrapper pt-0">
        <div className="select-all-header-wrapper">
          <div className="settings-header">
            <h3>Alerts & Notifications</h3>
          </div>
          <div className="d-flex form-group align-items-center">
            <Checkbox
              checked={areAllSelected(alerts)}
              onChange={(e) => {
                handleAlertsToggle(alerts, e.target.checked);
              }}
              id="select-all-alerts"
              externalLabel={{ label: "Select All" }}
            />
          </div>
        </div>

        <div className="alerts-notifications-checkboxes-wrapper">
          <div className="alerts-notifications-checkbox" key={alertKey}>
            <Checkbox
              checked={
                _.get(alerts, "communication", "") === "yes" ? true : false
              }
              name="communication"
              onChange={(e) => {
                handleAlertsChange(e);
              }}
              id="communication"
            />
            <span className="activity">
              <label htmlFor="communication">
                <span className="font-bold-600"><EmployHERName /> Communication</span>
                <br />
                <span className="info-text">
                  Get <EmployHERName /> news,
                  announcements, and products updates
                </span>
              </label>
            </span>
          </div>
          <div className="alerts-notifications-checkbox">
            <Checkbox
              checked={_.get(alerts, "activity", "") === "yes" ? true : false}
              name="activity"
              onChange={(e) => {
                handleAlertsChange(e);
              }}
              id="activity"
            />
            <span className="activity">
              <label htmlFor="activity">
                <span className="font-bold-600"><EmployHERName /> Activity</span> <br />
                <span className="info-text">
                  Get important notifications about you or activity you’ve
                  missed
                </span>
              </label>
            </span>
          </div>
          <div className="alerts-notifications-checkbox">
            <Checkbox
              checked={
                _.get(alerts, "reminders", "") === "yes" ? true : false
              }
              name="reminders"
              onChange={(e) => {
                handleAlertsChange(e);
              }}
              id="reminders"
            />
            <span className="activity">
              <label htmlFor="reminders">
                <span className="font-bold-600">Reminders</span>
                <br />
                <span className="info-text">
                  Receive appointment remainders, and other reminders related
                  to your activities on <EmployHERName />.
                </span>
              </label>
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div className="alerts-notifications-wrapper">
        <div className="select-all-header-wrapper">
          <div className="settings-header">
            <h3>Account Activity</h3>
            <p className="font-md">Email me when:</p>
          </div>
          <div className="d-flex form-group align-items-center">
            <Checkbox
              checked={areAllSelected(activities)}
              onChange={(e) => {
                handleActivityToggle(activities, e.target.checked);
              }}
              id="select-all-activities"
              externalLabel={{ label: "Select All" }}
            />
          </div>
        </div>
        <div className="alerts-notifications-checkboxes-wrapper no-gap">
          <div className="alerts-notifications-checkbox" key={activityKey}>
            <Checkbox
              checked={
                _.get(activities, "comment", "") === "yes" ? true : false
              }
              name="comment"
              onChange={(e) => {
                handleActivityChange(e);
              }}
              id="comment"
              externalLabel={{ label: "Someone comments on one of my job post" }}
            />
          </div>
          <div className="alerts-notifications-checkbox">
            <Checkbox
              checked={
                _.get(activities, "mention", "") === "yes" ? true : false
              }
              name="mention"
              onChange={(e) => {
                handleActivityChange(e);
              }}
              id="mention"
              externalLabel={{ label: "Someone mentions me" }}
            />

          </div>
          <div className="alerts-notifications-checkbox">
            <Checkbox
              checked={
                _.get(activities, "invite", "") === "yes" ? true : false
              }
              name="invite"
              onChange={(e) => {
                handleActivityChange(e);
              }}
              id="invite"
              externalLabel={{ label: "I receive invitations to invite new post" }}
            />

          </div>
          <div className="alerts-notifications-checkbox">
            <Checkbox
              checked={
                _.get(activities, "accepts_invitation", "") === "yes"
                  ? true
                  : false
              }
              name="accepts_invitation"
              onChange={(e) => {
                handleActivityChange(e);
              }}
              id="accepts_invitation"
              externalLabel={{ label: "Someone accepts my invitation" }}
            />
          </div>
          <div className="alerts-notifications-checkbox">
            <Checkbox
              checked={
                _.get(activities, "follow", "") === "yes" ? true : false
              }
              name="follow"
              onChange={(e) => {
                handleActivityChange(e);
              }}
              id="follow"
              externalLabel={{ label: "Anyone follows me" }}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="alerts-notifications-wrapper">
        <div className="select-all-header-wrapper">
          <div className="settings-header">
            <h3>Account Support</h3>
            <p className="font-md">Email me when:</p>
          </div>
          <div className="d-flex form-group align-items-center">
            <Checkbox
              checked={areAllSelected(supports)}
              onChange={(e) => {
                handleSupportsToggle(supports, e.target.checked);
              }}
              id="select-all-supports"
              externalLabel={{ label: "Select All" }}
            />
          </div>
        </div>
        <div className="alerts-notifications-checkboxes-wrapper no-gap">
          <div className="alerts-notifications-checkbox" key={supportKey}>
            <Checkbox
              checked={
                _.get(supports, "privacy_policy", "") === "yes" ? true : false
              }
              name="privacy_policy"
              onChange={(e) => {
                handleSupportChange(e);
              }}
              id="privacy_policy"
            />
            <span className="activity">
              <label htmlFor="privacy_policy">
                <span className="font-bold-600">Get notified when <EmployHERName /> changed in the privacy policy and terms of services.</span>
              </label>
            </span>
          </div>
          <div className="alerts-notifications-checkbox">
            <Checkbox
              checked={
                _.get(supports, "unsubscribe", "") === "yes" ? true : false
              }
              name="unsubscribe"
              onChange={(e) => {
                handleSupportChange(e);
              }}
              id="unsubscribe"
              externalLabel={{ label: "Unsubscribe from all the marketing emails" }}
            />
          </div>
        </div>
      </div>
      <div className="update-email-notifications-wrapper">
        <Button
          onClick={() => handleUpdateNotification()}
        >
          Update Notifications
        </Button>
      </div>
    </div>
  );
};

export default Notifications;
